module.exports = __webpack_public_path__ + "img/home-compac3.3e39f611.png";